class Bundlebar {
    constructor(config = { overlay: true, blur: false }) {
      this.activeId;
      this.activeElement;
      this.overlayElement;
      if (config.overlay) {
        this.overlayElement = document.createElement("div");
        // this.overlayElement.classList.add("bundlebar_overlay");
        document.querySelector("body").appendChild(this.overlayElement);
      }
      if (config.blur) {
        const mainContent = document.querySelector(".bundlebar_main_content");
        if (mainContent) {
          mainContent.classList.add("bundlebar_blur");
        }
      }
      this.bindEvents();
    }
  
    emitOpening() {
      const event = new CustomEvent("bundlebar_opening", {
        bubbles: true,
        detail: { element: this.activeElement, id: this.activeId },
      });
      this.activeElement.dispatchEvent(event);
    }
  
    emitClosing() {
      const event = new CustomEvent("bundlebar_closing", {
        bubbles: true,
        detail: { element: this.activeElement, id: this.activeId },
      });
      this.activeElement.dispatchEvent(event);
    }
  
    handleOpenEvent(e) {
      e.preventDefault();
      const bundlebarId = e.currentTarget.getAttribute("data-bundlebar-target");
      this.open(bundlebarId);
    }
  
    handleCloseEvent(e) {
      e.preventDefault();
      this.close();
    }
  
    handleKeyEvent(e) {
      if (e.keyCode === 27) this.close();
    }
  
    bindEvents() {
      const triggers = document.querySelectorAll("[data-bundlebar-target]");
      const closers = document.querySelectorAll("[data-bundlebar-close]");
      triggers.forEach((trigger) =>
        trigger.addEventListener("click", (e) => this.handleOpenEvent(e), false)
      );
      closers.forEach((closer) =>
        closer.addEventListener("click", (e) => this.handleCloseEvent(e), false)
      );
      if (this.overlayElement) {
        this.overlayElement.addEventListener(
          "click",
          (e) => this.handleCloseEvent(e),
          false
        );
      }
      document.addEventListener("keyup", (e) => this.handleKeyEvent(e));
    }
  
    open(bundlebarId) {
      if (this.activeId === String(bundlebarId) || !bundlebarId) return;
      if (this.activeId && this.activeId !== String(bundlebarId)) this.close();
      this.activeId = bundlebarId;
      this.activeElement = document.querySelector(
        `[data-bundlebar-id="${this.activeId}"]`
      );
      if (!this.activeElement) return;
      this.emitOpening();
      this.activeElement.classList.add("opened");
      const pageRootElement = document.querySelector("html");
      pageRootElement.classList.add("bundlebar_locked");
      pageRootElement.setAttribute("bundlebar", bundlebarId);
    }
  
    close() {
      if (!this.activeId) return;
      this.emitClosing();
      this.activeElement.classList.remove("opened");
      const pageRootElement = document.querySelector("html");
      pageRootElement.classList.remove("bundlebar_locked");
      pageRootElement.removeAttribute("bundlebar");
      this.activeId = null;
      this.activeElement = null;
    }
  }
  